export default __webpack_public_path__ + "static/media/voice-cloning-feature.64cbaec3.webp";